import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class spaceAfterDataService {
    public subscriber: Subject<boolean> = new Subject<boolean>();
}